import { render, staticRenderFns } from "./display-loading.vue?vue&type=template&id=4ed45128&scoped=true&"
import script from "./display-loading.vue?vue&type=script&lang=js&"
export * from "./display-loading.vue?vue&type=script&lang=js&"
import style0 from "./display-loading.vue?vue&type=style&index=0&id=4ed45128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed45128",
  null
  
)

export default component.exports